export const offerSalesTablesContainer = {
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    allInputsRequired: {
      type: Boolean,
      default: false,
    },
    repeatedSkus: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: '',
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isMercapromoCampaign: {
      type: Boolean,
      default: false,
    },
    hideCardShadow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    helpers: {
      wrongEAN: [],
      groupWrongEAN: [],
    },
  }),
  computed: {
    showGroupedTable() {
      return this.groupedProducts && this.groupedProducts.length > 0
    },
    showUngroupedTable() {
      return (this.ungroupedProducts.length && this.groupedProducts.length) || !this.groupedProducts.length
    },
    ungroupedProducts() {
      if (!this.campaign[this.offerSalesType]) return []
      return this?.campaign[this.offerSalesType].filter((product) => !product.isGroup)
    },
    groupedProducts() {
      if (!this?.campaign[this.offerSalesType]) return []
      return this?.campaign[this.offerSalesType].filter((product) => product.isGroup)
    },
    modules() {
      return this.$getAllowedModules()
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    automaticCampaign() {
      return Boolean(['erp'].includes(this?.campaign?.origin))
    },
    groupDescription() {
      return 'Nessa sessão estão listados os grupos incluídos na sua oferta. Eles ficam separados para você poder tomar decisões e editar o que achar necessário para seus grupos de forma individual.'
    },
    industryRebateWarning() {
      return '<span style="color: #086A29">Todo o valor do desconto concedido para o consumidor através desta oferta será reembolsado pela indústria. Portanto essa oferta não gera diminuição da margem do produto.</span>'
    },
  },

  methods: {
    changeGroupExhibition(type, groupId) {
      const newOfferSales = this.campaign[this.offerSalesType].map((offer) => {
        if (offer._id === groupId) {
          return {
            ...offer,
            group_rules_exhibition: type,
            maximum_per_client: type === 'PUBLIC' ? 0 : offer.maximum_per_client,
            minimum_per_client: type === 'PUBLIC' ? 0 : offer.minimum_per_client,
          }
        }
        return offer
      })
      this.campaign[this.offerSalesType] = newOfferSales
    },
    removeItem({ item, groupId }) {
      if (groupId) {
        const newOfferSales = this.campaign[this.offerSalesType].map((offer) => {
          if (offer._id === groupId) {
            return {
              ...offer,
              products: offer.products
                .map((product) => {
                  if (product.sku !== item.sku) return product
                })
                .filter((item) => item),
            }
          }
          return offer
        })
        this.campaign[this.offerSalesType] = newOfferSales
      } else {
        const newOfferSales = this.campaign[this.offerSalesType]
          .map((offer) => {
            if (offer.sku !== item.sku) return offer
          })
          .filter((item) => item)
        this.campaign[this.offerSalesType] = newOfferSales
      }
    },
    removeGroup(groupId) {
      const newOfferSales = this.campaign[this.offerSalesType]
        .map((offer) => {
          if (offer._id !== groupId) return offer
        })
        .filter((item) => item)
      this.campaign[this.offerSalesType] = newOfferSales
    },
    checkValidations() {
      this.campaign[this.offerSalesType].forEach((item, index) => {
        if (item.eans && item.eans.length === 0) this.helpers.wrongEAN[index] = true
        else this.helpers.wrongEAN = []
      })

      this.$v.$touch()
      if (this.$refs[this.offerSalesType]) this.$refs[this.offerSalesType].options.page = 1
      return new Promise((resolve) => {
        setTimeout(() => {
          this.sortProducts()
          resolve()
        }, 0)
      }).then(() => {
        if (this.$v.$error) {
          this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
          return false
        } else {
          return true
        }
      })
    },
    async sortProducts() {
      const batchSize = 50
      const totalProducts = this.ungroupedProducts.length
      const validProducts = []
      const invalidProducts = []
      let currentIndex = 0

      const processBatch = async () => {
        for (let i = 0; i < batchSize && currentIndex < totalProducts; i++) {
          const isProductInvalid = this.$v.ungroupedProducts.$each[currentIndex].$error
          const product = this.ungroupedProducts[currentIndex]

          if (isProductInvalid) {
            invalidProducts.push(product)
          } else {
            validProducts.push(product)
          }
          currentIndex++
        }
        if (currentIndex < totalProducts) {
          await new Promise((resolve) => setTimeout(resolve, 0))
          processBatch()
        } else {
          this.campaign[this.offerSalesType] = [...invalidProducts, ...validProducts, ...this.groupedProducts]
        }
      }
      await processBatch()
    },
  },
}
